import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const CUISINE_TYPE_NODE_FRAGMENT = gql`
  fragment CuisineTypeNodeFragment on CuisineTypeNode {
    ...MetadataNodeFragment
    isErrorProne

    replaces {
      ...MetadataNodeFragment
      replaceToken
    }

    replacedBy {
      ...MetadataNodeFragment
      replaceToken
    }

    children {
      ...MetadataNodeFragment
      isErrorProne

      replaces {
        ...MetadataNodeFragment
        replaceToken
      }

      replacedBy {
        ...MetadataNodeFragment
        replaceToken
      }

      children {
        ...MetadataNodeFragment
        isErrorProne

        replaces {
          ...MetadataNodeFragment
          replaceToken
        }

        replacedBy {
          ...MetadataNodeFragment
          replaceToken
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default CUISINE_TYPE_NODE_FRAGMENT
